import { DesignObligation, MaturityStage, ProductBuildingBlock } from '@/gql/graphql';
import { useCallback, useState } from 'react';
import {
  SortBy,
  SortedBuildingBlock,
  filterIncludedBuildingBlocks,
  fiterExcludedBuildingBlocks,
  sortByDesignObligation,
  sortByMaturityStage,
} from './use-building-blocks.hook.core';

type BuildingBlocksHook = {
  sort: SortBy;
  selectedBuildingBlock: ProductBuildingBlock | undefined;
  setSelectedBuildingBlock: (bb: ProductBuildingBlock | undefined) => void;
  handleSortChange: (value: SortBy) => void;
  includedBuildingBlocks: SortedBuildingBlock<DesignObligation | MaturityStage>;
  excludedBuildingBlocks: SortedBuildingBlock<DesignObligation | MaturityStage>;
};

type BuildingBlocksHookProps = {
  buildingBlocks?: ProductBuildingBlock[];
};

export const useBuildingBlocks = ({ buildingBlocks }: BuildingBlocksHookProps): BuildingBlocksHook => {
  const [sortBy, setSortBy] = useState<SortBy>('DO');
  const [selectedBuildingBlock, setSelectedBuildingBlock] = useState<ProductBuildingBlock | undefined>();

  const handleSortChange = (value: SortBy) => {
    setSortBy(value);
  };

  const includedBuildingBlocks = useCallback(() => filterIncludedBuildingBlocks(buildingBlocks), [buildingBlocks]);
  const excludedBuildingBlocks = useCallback(() => fiterExcludedBuildingBlocks(buildingBlocks), [buildingBlocks]);

  return {
    sort: sortBy,
    handleSortChange,
    selectedBuildingBlock,
    setSelectedBuildingBlock,
    includedBuildingBlocks:
      sortBy === 'DO'
        ? sortByDesignObligation(includedBuildingBlocks())
        : sortByMaturityStage(includedBuildingBlocks()),
    excludedBuildingBlocks:
      sortBy === 'DO'
        ? sortByDesignObligation(excludedBuildingBlocks())
        : sortByMaturityStage(excludedBuildingBlocks()),
  };
};
